import { render } from "./BlockHandleMenu.vue?vue&type=template&id=be7b69b0"
import script from "./BlockHandleMenu.vue?vue&type=script&lang=js"
export * from "./BlockHandleMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__